import {
    CardCollection,
    Instance,
    Knot,
    Objekt,
    Promize,
} from '@siposdani87/sui-js';
import { app } from '../app';
import { AssetService } from '@services/assetService';
import { ChamberService } from '@services/chamberService';
import { LanguageService } from '@services/languageService';
import { initCardCollection } from '@utils/collectionSetup';
import { DashboardController } from './dashboardController';

export class ChambersIndexController extends DashboardController {
    static readonly inject = [
        'instances',
        'chamberService',
        'assetService',
        'languageService',
    ] as const;

    chamberCardCollection!: CardCollection;

    constructor(
        instances: Instance,
        private chamberService: ChamberService,
        private assetService: AssetService,
        private languageService: LanguageService,
    ) {
        super(instances);
    }

    protected override _initLayout(): void {
        this._initToolbarButtons();
        this._initFilterForm();

        this._drawContent();
    }

    protected override _drawContent(): Promize | boolean {
        this._initChamberCardCollection();
        return true;
    }

    private _initToolbarButtons(): void {
        this.helper.iconButton('.btn-site-home', this.dom, () => {
            this.state.goBack('site.home');
        });
    }

    private _initChamberCardCollection(): void {
        this.chamberCardCollection = initCardCollection(
            this.chamberCardCollection,
            this.dom,
            '.chamber-collection',
            this.chamberService,
            {
                entityKey: 'chambers',
                fetchData: (params) => this.chamberService.getAll(params),
                extraParams: (params) => {
                    params.set('query', this.query);
                    params.set('fields', 'id,name,logo');
                },
            },
            this._eventCardKnot.bind(this),
        )!;
    }

    private _eventCardKnot(cardKnot: Knot, chamber: Objekt): void {
        this._initChamberShowButton(cardKnot, chamber);
    }

    private _initChamberShowButton(cardKnot: Knot, chamber: Objekt): void {
        this.helper.link(
            'a.card',
            cardKnot,
            (href) => {
                this.state.go(href);
            },
            this.state.resolveUrl('chambers.show', {
                chamberId: chamber.get<string>('id'),
            }),
        );
    }
}

export const chambersIndexController = app.controller(
    'chambersIndexController',
    ChambersIndexController,
);
